import React, { FC, ReactElement } from 'react';

import './src/styles/global.css';
import { AppProvider } from './src/state';
import { ThemeProviderWrapper } from './src/theme/context';

interface WrapRootElementProps {
  element: ReactElement;
}

export const wrapRootElement: FC<WrapRootElementProps> = ({
  element,
}): ReactElement => (
  <ThemeProviderWrapper>
    <AppProvider>{element}</AppProvider>
  </ThemeProviderWrapper>
);
